<div [class.four-columns]="viewletType()===E_VIEWLET_TYPE.GlobalSubPagesType1"
     class="grid-table">

  <!--  GlobalMain-->
  @switch (viewletType()) {
    @case (E_VIEWLET_TYPE.GlobalMain) {
      @if (projects().length) {
        <div class="grid-header">{{ 'Project' | translate }}</div>
        <div class="grid-header">{{ 'Summary' | translate }}</div>
        @for (project of projects(); track project.id) {
          @switch (viewletType()) {
            @case (E_VIEWLET_TYPE.GlobalMain) {
              <div class="grid-cell project-title">
                <a [href]="HELPER.getUrl(project.sourceUrl)">{{ project.title }}</a>
              </div>
              <div class="grid-cell" [innerHTML]="project.summary | safeHtml"></div>
            }
          }
        }
      }
    }

    <!--    GlobalSubPagesType1-->
    @case (E_VIEWLET_TYPE.GlobalSubPagesType1) {
      @if (flatProjects().length) {
        <div class="grid-header">{{ 'Project' | translate }}</div>
        <div class="grid-header">{{ 'Current status' | translate }}</div>
        <div class="grid-header">{{ 'Next project step' | translate }}</div>
        <div class="grid-header">{{ 'Expected timing' | translate }}</div>
        @for (project of flatProjects(); track project.id) {
          <div class="grid-cell project-title">
            <a [href]="HELPER.getUrl(project.sourceUrl)">{{ project.title }}</a>
          </div>
          <div class="grid-cell" [innerHTML]="project.lastStep | getStep | safeHtml | translate"></div>
          <div class="grid-cell" [innerHTML]="project.nextStep | getStep | safeHtml | translate"></div>
          <div class="grid-cell">
            @if (project.nextStepDate) {
              <span class="date">{{ HELPER.formatDateWithLocalizedMonth(project.nextStepDate) }}</span>
              <br>
            }
            <span [innerHTML]="project.nextStepDateDescription| safeHtml"></span>
          </div>
        }
      }
    }


    <!--    GlobalSubPagesType2-->
    @case (E_VIEWLET_TYPE.GlobalSubPagesType2) {
      @if (flatProjects().length) {
        <div class="grid-header">{{ 'Title' | translate }}</div>
        <div class="grid-header">{{ 'Description' | translate }}</div>
        @for (project of flatProjects(); track project.id) {
          <div class="grid-cell project-title">
            <a [href]="HELPER.getUrl(project.sourceUrl)">{{ project.title }}</a>
          </div>
          <div class="grid-cell" [innerHTML]="project.summary || project.htmlDescription | safeHtml"></div>
        }
      }
    }

    <!--    UKMain-->
    @case (E_VIEWLET_TYPE.UKMain) {
      @if (projects().length) {
        <div class="grid-header">{{ 'Project' | translate }}</div>
        <div class="grid-header">{{ 'Summary' | translate }}</div>
        @for (project of projects(); track project.id) {
          <div class="grid-cell project-title">
            <a [href]="HELPER.getUrl(project.sourceUrl)">{{ project.title }}</a>
          </div>
          <div class="grid-cell" [innerHTML]="project.summary | safeHtml"></div>
        }
      }
    }

    <!--    UKMain-->
    @case (E_VIEWLET_TYPE.Canada) {
      @if (flatProjects().length) {
        <div class="grid-header">{{ 'Project' | translate }}</div>
        <div class="grid-header">{{ 'Description' | translate }}</div>
        @for (project of flatProjects(); track project.id) {
          <div class="grid-cell project-title">
            <a [href]="HELPER.getUrl(project.sourceUrl)">{{ project.title }}</a>
          </div>
          <div class="grid-cell" [innerHTML]="project.htmlDescription | safeHtml"></div>
        }
      }
    }

  }


</div>
